import { ListBooking } from 'types';

const shouldUpdatePaymentMethod = (booking: ListBooking): boolean => {
  const { hasPendingScheduledPayment, isCreditCardExpired } = booking.flags;
  return hasPendingScheduledPayment && isCreditCardExpired;
};

export default shouldUpdatePaymentMethod;
